import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { AuthService } from "../services/auth.service";
import { FlashMessagesService } from 'ngx-flash-messages'; 


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public loading = false
  username:string;
  password:string;
  token:any;
  usertype:any;
  
  invalidCredentialsMsg:string;
  
  constructor(
    private authservice:AuthService,
    private router:Router,
    private flashmsg:FlashMessagesService
  ) { }

  ngOnInit() {
  }

  
  

  onLoginSubmit(){
    let uname = this.username;
    let pwd = this.password;
    this.loading =true
    this.authservice.getToken(uname,pwd).subscribe(data=>{
      localStorage.setItem('tokenData', JSON.stringify(data))
      this.token = data.access_token
      localStorage.setItem('access_token',this.token)
      this.authservice.authenticate(this.token).subscribe( userData =>{
      localStorage.setItem('userData', JSON.stringify(userData))   
      if(userData){
        this.loading =false
        this.flashmsg.show('Welcome',
        {classes:['alert-success'], timeout:5000});
        let url =this.authservice.getRedirectUrl();
        console.log('Redirect Url:' + url);
        this.router.navigate([url])
        this.authservice.getProfile(data.access_token).subscribe( user=>{
          localStorage.setItem('USER',JSON.stringify(user))
          this.usertype =user.type
          localStorage.setItem('USER-TYPE',this.usertype)
          this.authservice.userType(user.type)
        })
      }
      }
      );

    }, error => {
      console.log(error)
      this.flashmsg.show( 'Ooops !'+' '+error,{classes:['alert-danger'], timeout:3000});
      this.invalidCredentialsMsg = error ;
      this.loading =false
    } )
  }
}



// WEBPACK FOOTER //
// D:/PROJECTS/Sokousoni/winda-dashboard/dashboard-winda-mvp/src/app/login/login.component.ts